const hideSearchModal = {
  type: 'setLayoutProperty',
  data: {
    path: 'components.SearchModal.properties.componentVisible',
    value: false,
  },
};

export const searchController = {
  initial: 'off',
  states: {
    off: {
      on: {
        VIEW_HEADER_SEARCH_CLICK: {
          actions: 'nav_HANDLE_CHANGE',
        },
        LAYOUT_CHANGE_END: {
          target: 'on',
          cond: 'isControllerEnabled_search',
        },
      },
    },
    on: {
      entry: ['trackOpenSearch'],
      initial: 'initializing',
      states: {
        initializing: {
          initial: 'prepareInputConfig',
          states: {
            prepareInputConfig: {
              always: [
                {
                  actions: [
                    {
                      type: ['prepareSearchInputConfig'],
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.SearchHeader.properties.inputConfig',
                        value: '$context.inputConfig',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                  ],
                  target: 'setNumberOfAllSearchGames',
                },
              ],
            },
            setNumberOfAllSearchGames: {
              always: [
                {
                  actions: [
                    {
                      type: ['setNumberOfAllSearchGames'],
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path:
                          'components.SearchHeader.properties.numberOfAllSearchGames',
                        value: '$context.numberOfAllSearchGames',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                  ],
                  target: 'removeLastPreviousPagePath',
                },
              ],
            },
            removeLastPreviousPagePath: {
              always: [
                {
                  actions: ['removeLastPreviousPagePath'],
                  cond: 'isSearchLastPath',
                  target: 'setBodyNonScrollable',
                },
                {
                  target: 'setBodyNonScrollable',
                },
              ],
            },
            setBodyNonScrollable: {
              always: [
                {
                  actions: ['setBodyNonScrollableDefaultTopPosition'],
                  target: 'manageHeader',
                },
              ],
            },
            manageHeader: {
              always: [
                {
                  target: 'fetchPhrases',
                },
              ],
            },
            fetchPhrases: {
              invoke: {
                src: 'fetchRecentPhrases',
                onDone: {
                  target: 'fetchingRPGames',
                  actions: [
                    {
                      type: 'save',
                      data: {
                        recentPhrases: '$event.data.recentPhrases',
                      },
                      meta: {
                        selectors: ['$action.data.recentPhrases'],
                      },
                    },
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                  ],
                },
              },
            },
            fetchingRPGames: {
              invoke: {
                src: 'fetchSearchRecentlyPlayedContent',
                onDone: {
                  target: 'idle',
                  actions: {
                    type: 'batchLayoutOperations',
                    data: '$event.data.updates',
                    meta: {
                      selectors: ['$action.data'],
                    },
                  },
                },
              },
            },
            idle: {
              on: {
                VIEW_CATEGORY_GAME_TILE_CLICK: [
                  {
                    actions: [
                      {
                        type: 'updatePhrases',
                      },
                      {
                        type: 'savePhrase',
                      },
                      {
                        type: 'sendAlgoliaAnalytics',
                        data: {
                          id: '$event.payload.id',
                        },
                        meta: {
                          selectors: ['$action.data.id'],
                        },
                      },
                      'resetSearchAttempts',
                    ],
                    cond: 'isGameLaunchedFromSearchCategory',
                  },
                  {
                    actions: [
                      {
                        type: 'updatePhrases',
                      },
                      {
                        type: 'savePhrase',
                      },
                      'resetSearchAttempts',
                    ],
                  },
                ],
                VIEW_SEARCH_CLEAR_CLICK: 'clearingPhrase',
                VIEW_SEARCH_SUBHEADER_ITEM_CLICK: 'subcategoryShow',
                VIEW_SEARCH_CLICK: {
                  target: 'searchingTitle',
                  actions: 'saveSearchInputType',
                },
                VIEW_SEARCH_CHANGE: {
                  target: 'searchingTitle',
                  actions: 'saveSearchInputType',
                },
                VIEW_SEARCH_PHRASE_CLICK: {
                  target: 'searchingTitle',
                  actions: [
                    'saveSearchInputType',
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path:
                          'components.SearchHeader.properties.suggestedPhrase',
                        value: '$event.payload.value',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                  ],
                },
                VIEW_SOFT_KEYBOARD_VISIBILITY_CHANGED: {
                  actions: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.ContentWrapper.properties.behavior',
                        value: '$event.payload.behavior',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                  ],
                },
                VIEW_RECENT_SEARCHES_CLEAR_CLICK: 'clearingRecentSearches',
                RELOAD_SEARCH_ITEMS: 'reloadSearchItems',
                CLEAR_SEARCH_PHRASE: 'clearingPhrase',
                VIEW_CATEGORY_GAME_TILE_INFO_CLICK: {
                  actions: hideSearchModal,
                },
                LOGIN_MODAL_STATE_CLOSED: 'clearingPhrase',
                RP_RERENDER: 'fetchingRP',
              },
            },
            fetchingRP: {
              invoke: {
                src: 'fetchSearchRecentlyPlayedContent',
                onDone: {
                  target: 'fetchPhrases',
                  actions: {
                    type: 'batchLayoutOperations',
                    data: '$event.data.updates',
                    meta: {
                      selectors: ['$action.data'],
                    },
                  },
                },
              },
            },
            clearingRecentSearches: {
              entry: [
                {
                  type: 'save',
                  data: {
                    recentPhrases: [],
                    phrasePendingAdditionToRecentPhrases: '',
                  },
                },
              ],
              invoke: {
                src: 'setSearchPhrases',
                onDone: {
                  target: 'idle',
                  actions: [
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                    {
                      type: 'savePhrase',
                    },
                  ],
                },
              },
            },
            clearingPhrase: {
              entry: 'clearSearch',
              always: 'setSearchResultContent',
            },
            searchingTitle: {
              entry: [
                {
                  type: 'updateCurrentPhrase',
                  data: {
                    value: '$event.payload.value',
                  },
                  meta: {
                    selectors: ['$action.data.value'],
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.SearchHeader.properties.isFetching',
                    value: true,
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: `components.SearchSuggestions.properties.isFetching`,
                    value: true,
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: `components.SearchHistory.properties.isFetching`,
                    value: true,
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: `components.SearchRecentlyPlayed.properties.isFetching`,
                    value: true,
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: `components.SearchResult.properties.isFetching`,
                    value: true,
                  },
                },
              ],
              invoke: {
                src: 'fetchSearchGames',
                onDone: {
                  target: 'fetchTableForSearchGames',
                  actions: [
                    {
                      type: 'save',
                      data: {
                        search: '$event.data.search',
                        games: '$event.data.games',
                      },
                      meta: {
                        selectors: [
                          '$action.data.search',
                          '$action.data.games',
                        ],
                      },
                    },
                  ],
                },
              },
            },
            fetchTableForSearchGames: {
              invoke: {
                src: 'fetchTableForSearchGames',
                onDone: {
                  target: 'setSearchResultContent',
                  actions: [
                    {
                      type: 'save',
                      data: '$event.data',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                  ],
                },
                onError: {
                  target: 'setSearchResultContent',
                },
              },
            },
            setSearchResultContent: {
              invoke: {
                src: 'setSearchResultsContent',
                onDone: {
                  target: 'checkingIfTrackSearch',
                  actions: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.SearchHeader.properties.isFetching',
                        value: false,
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: `components.SearchSuggestions.properties.isFetching`,
                        value: false,
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: `components.SearchHistory.properties.isFetching`,
                        value: false,
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: `components.SearchRecentlyPlayed.properties.isFetching`,
                        value: false,
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: `components.SearchResult.properties.isFetching`,
                        value: false,
                      },
                    },
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                    'getSearchGamesJackpotsV2',
                  ],
                },
              },
            },
            checkingIfTrackSearch: {
              always: [
                {
                  actions: ['updateSearchAttempts'],
                  target: 'trackSearchResult',
                  cond: 'isSearchPhraseCorrect',
                },
                {
                  target: 'idle',
                },
              ],
            },
            trackSearchResult: {
              entry: 'trackSearchResult',
              always: 'idle',
            },
            subcategoryShow: {
              entry: 'showGamesOfMatchingType',
              always: 'setSearchResultContent',
            },
            reloadSearchItems: {
              invoke: {
                src: 'getSearchItemsContent',
                onDone: {
                  target: 'idle',
                  actions: [
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                  ],
                },
              },
            },
          },
        },
      },
      on: {
        LAYOUT_CHANGE_END: [
          {
            target: 'off',
            cond: 'isControllerDisabled_search',
          },
          'refreshing',
        ],
      },
    },
    refreshing: {
      always: 'on',
    },
  },
};
